export default {
  route: {
    login: 'Login',
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    dragDialog: 'Drag Dialog',
    dragSelect: 'Drag Select',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Profile',
    movieManage: 'Movie Manage',
    movieList: 'Movie List',
    movieAdd: 'Movie Add',
    BatchUpdate: 'Batch change content',
    SimilarityVerification: 'Similarity Verification',
    seriesList: 'Series List',
    seriesAdd: 'Series Add',
    shortList: 'Short Video List',
    shortAdd: 'Short Video Add',
    ChannelPage: 'Channel Page',
    ChannelPageWindow: 'Channel Page Window Management',
    ChannelPageTag: 'Channel Page Tag Management',
    cdnDistribution: 'cdn distribution',
    ApplicationChannelGroup: 'Application channel group management',
    RankSingle: 'square navigation bar',
    RankSingleSetting: 'square navigation bar page setting',
    RankComponents: 'square component library',
    RankComponentsStyleTriage: 'square component library content',
    RankComponentsRealtime: 'Real-time style of large images',
    StyleTriageSingleManage: 'Sheet management',
    shortResources: 'Short Resources',
    seriesResources: 'Series Resources',
    movieResources: 'Movie Resources',
    aiTranslateTask: 'AI Translate Task Center',
    detailBanner: 'Detail Banner List',
    serviceManage: 'Service Manage',
    InterestTag: 'Interest tag setting',
    InterestTagContent: 'content management',
    ContentSee: 'Want to see the list',
    commonPopup: 'Common Popup',
    feedbackList: 'Feedback List',
    questionList: 'Feedback Type List',
    questionManage: 'Question Manage',
    questionSonList: 'questionSonList',
    taskCenter: 'Task Center',
    taskList: 'Task List',
    apiList: 'apiList',
    signConfig: 'signConfig',
    taskStore: 'Store List',
    integralDetail: 'Integral Detail',
    taskAuditList: 'Task Audit List',
    gameList: 'gameList',
    Withdraw: 'Withdraw',
    userManage: 'User Manage',
    userList: 'User List',
    userBlackList: 'user Black List',
    whiteList: 'user White List',
    userSuperWhiteList: 'List of internal super white users',
    userLabel: 'user device label',
    IdSearch: 'ID mapping list query',
    fission: 'Fission',
    activityManage: 'Activity Manage',
    topUpActivity: 'Top-up Activities',
    TeamUp: 'TeamUp',
    activityTemplate: 'Live event template',
    templateAdd: 'Live Events template added | edit',
    templateRank: 'Live activity template list',
    templateRankAdd: 'Live event template list added | edit',
    templateHonor: 'Hall of Honor editor',
    templateReward: 'Incentive allocation',
    searchSetting: 'Search Setting',
    aiSearchConfig: 'AI Search Config',
    articleManage: 'Article Manage',
    SystemArticle: 'System Article',
    DomainList: 'Domain List',
    promoteList: 'Promote List',
    homeSetting: 'Home Setting',
    homeTvSetting: 'Home TV Setting',
    singleList: 'Single List',
    singleAddContent: 'Single Add Content',
    plateSetting: 'plate Setting',
    developManage: 'Develop Manage',
    dicList: 'Dictionary List',
    yuque: 'Yu Que',
    pushList: 'Push List',
    createPush: 'Create Push',
    updatePush: 'Update Push',
    pushDetail: 'Push Detail',
    authSetting: 'Auth Setting',
    floatWindow: 'Floating Window',
    h5Share: 'H5 Share',
    H5ShareAdd: 'H5 Share Add',
    upList: 'Up List',
    regionList: 'Region List',
    adManage: 'Ad Manage',
    AdsListConfig: 'Product Listing Ads',
    adSwitch: 'Ad Switch',
    homePageList: 'Home Page List',
    homeTvPageList: 'TV Home Page List',
    vipManage: 'Vip Manage',
    vipDiscountCase: 'Discount Case',
    vipProduct: 'Vip Product',
    vipIssue: 'Vip Issue',
    vipActivityConfig: 'Vip Activity Config',
    vipCode: 'Vip Code',
    vipCodeDetail: 'Vip Code Detail',
    vipDetail: 'Vip Detail',
    barSetting: 'Bar Setting',
    configurManage: 'Online Manage',
    configur: 'Online Configur',
    infoList: 'Info List',
    telegramManage: 'Telegram Manage',
    CopyrightManage: 'Copyright Manage',
    cdnSetting: 'Cdn Setting',
    ugc: 'Ugc Manage',
    auditList: 'Audit List',
    auditOp: 'audit op',
    starList: 'star list',
    addStar: 'add star',
    addFission: 'add fission',
    setRule: 'set rule',
    rewardList: 'reward list',
    probabilityGame: 'probability game',
    probabilityGameSetting: 'game setting',
    probabilityGameSetting1: 'game setting',
    officialSetting: 'official Setting',
    starPk: 'star pk',
    addPkStar: 'add|edit',
    starPkReport: 'star pk report',
    starPkRewardSetting: 'star pk reward setting',
    gatePass: 'Gate Pass Manage',
    gatePassEdit: 'Add/Edit Gate Pass',
    fissionInvite: 'Fission Invite',
    jackpotNumberSetting: 'jackpot number setting',
    jackpotGiftSetting: 'jackpot gift setting',
    dataReport: 'data Report',
    dataReport1: 'data Report',
    emojiList: 'emoji list',
    VipPackage: 'Vip Package',
    watchTogether: 'watch together',
    crawlerManage: 'crawler manage',
    starInfoList: 'star info list',
    starInfoDetail: 'star info detail',
    contentManage: 'Content Manage',
    homeLargeWindow: 'Home Large Window',
    noteSwitchover: 'Note Switchover',
    communityManage: 'Community Manage',
    topicClassifManage: 'Topic classification management',
    ManualAdd: 'Add manual Posting',
    HotList: 'Hot List',
    singleRecommend: 'singleRecommend',
    SquareBanner: 'Square Banner configur',
    SquareBlock: 'Square Block configur',
    Waterfall: 'Waterfall configur',
    dynamicManage: 'message Manage',
    commentManage: 'Comment Manage',
    topicManage: 'Topic Manage',
    topicManageAdd: 'Add|Edit Topic Manage',
    detailTabConfigManage: 'Detail Tab Config Manage',
    discussDetail: 'Add|Edit Discuss Tab',
    playerDetail: 'Add|Edit Player Detail Config',
    customDetail: 'Add|Edit Player Custom Tab',
    goodsAndOrder: 'Virtual Currency Manage',
    virtualCurrencyManage: 'Goods Manage',
    payManage: 'Pay Manage',
    provideManage: 'Provide Manage',
    VirtualCurrencyManageContent: 'PageSetting|Content',
    virtualCurrencyItemized: 'Goods Itemized',
    orderItemized: 'order Manage',
    goodsItemized: 'Gift Itemized',
    goodsList: 'Gift List',
    escortManage: 'Escort Manage',
    UserList: 'User List',
    CashOutManage: 'Cash Out Manage',
    firstPaySettings: 'First Pay Settings',
    Settings: 'Configuration modification',
    escortReportList: 'Escort Report List',
    escortOrderList: 'Escort Order List',
    vipGoods: 'Vip Goods Settings',
    anchorLive: 'Anchor Management',
    salary: 'salary',
    salaryMonthAnchor: 'salaryMonthAnchor',
    salaryRecordDetail: 'salaryRecordDetail',
    salaryMonthAnchorDetail: 'salaryMonthAnchorDetail',
    dayItemized: 'Daily Itemized',
    monthItemized: 'Month Itemized',
    guildManage: 'Guild Management',
    liveDetail: 'Live Details',
    liveConfig: 'Live Config',
    tvLive: 'TV live streaming source',
    tvClassify: 'Classified of TV live ',
    tvSearchKeyword: 'tvSearchKeyword',
    tvClassifyManage: 'Channel Management',
    liveSound: 'Live Sound Effects',
    sportsLive: 'Sports Live H5',
    bannerConfig: 'Banner Config',
    PositionConfig: 'Recommended bit configuration',
    RecommendExposure: 'Exposure data recognizer',
    HomeRecommendRange: 'Home Page Featured',
    liveSwitch: 'Live Function Entry',
    runwayConfig: 'Runway Config',
    musicUpload: 'Music Upload',
    hotSearchRecommendation: 'Hot Search Recommendation',
    atmosphereConfig: 'Atmosphere Config',
    userTask: 'User Task Manage',
    dressConfig: 'Dress Config',
    anchorTask: 'Anchor Task',
    dressItemized: 'Dress Itemized',
    agentManage: 'Agent Manage',
    punishRecord: 'Punish Records',
    floatingConfig: 'Floating Window Config',
    liveRoom: 'LiveRoom Management',
    liveRoomRecommendRange: 'LiveRoom Artificial Recommend',
    gameSwitch: 'Game Switch',
    liveSettlement: 'Live Settlement',
    anchorRecommend: 'Anchor Recommend',
    incomeSettings: 'Settlement Configuration',
    liveRoomCategory: 'LiveRoom Category Config',
    liveRoomCategoryListSecond: 'Second Category Setting',
    refundList: 'Refund List',
    guildRoom: 'Guild Room',
    guildRoomReport: 'Guild Room Report',
    guildRoomReportCustom: 'Custom Guild Room Report',
    deviceManage: 'Login device restriction management',
    detailThrottleConfig: 'Detail page throttle',
    countryGroup: 'Country Group',
    appointment: 'appointment',
    vipConfigurationManage: 'Configuration List',
    autoPushList: 'Auto Push List',
    emailRecall: 'Email Recall',
    liveFunctionConfig: 'live Function Config',
    liveRoomWindow: 'live room window',
    biscuitsExchange: 'Biscuits Exchange',
    areaFilter: 'Area Filter',
    sensitive: 'sensitive',
    vipSubscription: 'Subscription Management',
    episodePay: 'Episode Pay',
    episodePayEdit: 'Save Episode Pay',
    episodeBuyItemized: 'Episode Buy Itemized',
    adList: 'Ad List',
    luckGoods: 'Luck Goods',
    report: 'Report',
    poolSetting: 'Pool Setting',
    RevealAd: 'Advertising video configuration',
    brandTakeover: 'Brand Takeover Setting',
    labelConfig: 'Label Config',
    labelSend: 'Label Send',
    labelRecycle: 'Label Recycle',
    reportCenter: 'Report Center',
    rankManage: 'Rank Manage',
    rankBlacklist: 'Rank Blacklist',
    rankList: 'Rank List',
    shortRecommendation: 'Short Recommendation',
    shortsSearchDramaConfig: 'Shorts Search Drama Config',
    searchDramaLabelRecommendation: 'Search Drama Label Recommendation',
    ShortBottomBarBubbleTip: 'Short Drama Bottom Bar Bubble Tip',
    sharing: 'Sharing Manage',
    shortManage: 'Short Manage',
    ShortRankManage: 'Short Rank Manage',
    ShortRankBlacklist: 'Short Rank Blacklist',
    ShortRankList: 'Short Rank List',
    shortsNavigationConfig: 'Short Navigation Bar Configuration',
    shortPageSetting: 'Short Page Setting',
    recommendationContent: 'Recommendation Content',
    withdrawInShort: 'Withdraw Manage',
    ReviewManage: '审核管理',
    ReviewDetail: '审核详情',
    Reviewer: '审核人员管理',
    InitialReview: '初审审核',
    FinalReview: '复审审核',
    episodeStatistics: 'Upload episode statistics',
    episodeStatisticsCheck: 'Upload episode statistics',
    ratioAllocation: 'proportional allocation'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips:
      'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    dropzoneTips:
      'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2:
      'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips:
      'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  example: {
    warning:
      'Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  btn: {
    back: 'Back',
    publish: 'Publish',
    next: 'Next',
    previous: 'Previous'
  }
}
